export const authContractLimits = {
  usernameMaxLength: 120,
  emailMaxLength: 255,
  displayNameMaxLength: 120,
  resetTokenMaxLength: 500
} as const

export const purchaseRequestContractLimits = {
  titleMaxLength: 200,
  explanationMaxLength: 1000,
  commentMaxLength: 1000,
  itemNameMaxLength: 200,
  itemSupplierMaxLength: 200,
  itemExplanationMaxLength: 1000,
  itemQuantityMin: 1,
  itemQuantityMax: 100000,
  itemPriceMin: 0,
  itemPriceMax: 100000000,
  projectsMaxCount: 10,
  revisionReasonMaxLength: 300,
  revisionItemsMaxCount: 500
} as const

export const projectContractLimits = {
  nameMaxLength: 200
} as const

export const invoiceContractLimits = {
  invoiceNumberMaxLength: 100,
  supplierMaxLength: 200,
  itemQuantityMin: 1,
  itemQuantityMax: 100000,
  totalAmountMin: 0.01,
  duplicateOverrideReasonMaxLength: 500,
  invoiceDispatchWarningDaysMin: 1,
  invoiceDispatchWarningDaysMax: 365,
  duplicateDismissalMaxInvoices: 20
} as const

/**
 * `SendInvoiceToPaymentRequest` of the contract and backend `InvoicePaymentTranchePolicy`:
 * `0 < amount`, `0 < sharePercent <= 100` (of the invoice total), two decimals, `note` up to 500 characters.
 */
export const invoiceTrancheConstraints = {
  noteMaxLength: 500,
  amountExclusiveMin: 0,
  /** `SendInvoiceToPaymentRequest.amount.maximum`: the bound of `numeric(18,2)`. */
  amountMax: 9_999_999_999_999.99,
  sharePercentExclusiveMin: 0,
  sharePercentMax: 100,
  fractionDigits: 2
} as const

/** Matches backend `NotificationTemplateChannelUpdatePolicy` for the `inapp` channel template. */
export const notificationTemplateContractLimits = {
  inAppTitleMaxLength: 200,
  inAppBodyMaxLength: 1000
} as const

export const feedbackContractLimits = {
  textMaxLength: 5000
} as const

export const invoiceLedgerConstraints = {
  payment: {
    notesMaxLength: 1000,
    revertReasonMaxLength: 500,
    amountMin: 0.01,
    /** Matches backend `FileUploadSecurityPolicy.MaxFilesPerRequest` for payment proof batch. */
    maxProofFiles: 5
  },
  paymentDocument: {
    documentNumberMaxLength: 64,
    notesMaxLength: 500
  },
  receipt: {
    documentNumberMaxLength: 64,
    notesMaxLength: 1000,
    revertReasonMaxLength: 500,
    actualItemNameMaxLength: 500
  },
  receiptDocument: {
    documentNumberMaxLength: 64,
    notesMaxLength: 500
  },
  ledgerProfileUpload: {
    acceptAttribute: '.pdf,.jpg,.jpeg,.png',
    allowedMimeTypes: ['application/pdf', 'image/jpeg', 'image/png'] as const
  }
} as const

export const metrologyContractLimits = {
  instrumentNameMaxLength: 200,
  oneSCodeMaxLength: 50,
  measurementRangeMaxLength: 100,
  scaleDivisionMaxLength: 50,
  serialNumberMaxLength: 100,
  setCompositionMaxLength: 2000,
  issueDocumentNumberMaxLength: 50,
  notesMaxLength: 2000,
  actionCommentMaxLength: 2000,
  blockedHolderCommentMaxLength: 2000,
  rejectReasonMaxLength: 2000,
  writeOffActNumberMaxLength: 50,
  extraordinaryReasonMaxLength: 500,
  externalPerformerMaxLength: 200,
  calibrationBasisMaxLength: 500,
  calibrationCommentMaxLength: 2000,
  calibrationIntervalMonthsMin: 1,
  calibrationIntervalMonthsMax: 120,
  calibrationIntervalMonthsDefault: 12,
  dictionaryNameMaxLength: 120,
  searchMaxLength: 200,
  holdersLookupMaxLimit: 50
} as const
